import { useContext, useEffect, useState } from "react";
import { apiService } from "service/ApiService";
import UserCreditsContext from "contexts/UserCreditsContext";

function CreditsItem() {
  const [myCredits, setMyCredits] = useState(0);
  const { refreshCredits, setRefreshCredits } = useContext(UserCreditsContext);

  const fetchUserCredits = async () => {
    try {
      console.log(`CreditsItem.fetchUserCredits()`);
      const credits = await apiService.getCredits();
      setRefreshCredits(false);
      setMyCredits(credits);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!apiService.isReseller() || !refreshCredits) return;
    fetchUserCredits();
  }, [refreshCredits]);

  return apiService.isReseller() ? (
    <>
      <div>
        <span className="sidebar-mini">
          <i className="nc-icon nc-credit-card"></i>
        </span>
        <span className="sidebar-normal">Credits: {myCredits}</span>
      </div>
      <div className="divider"></div>
    </>
  ) : (
    ""
  );
}

export default CreditsItem;
